<!--
 * @Author: Ashley.Liu
 * @Date: 2022-06-12 16:15:43
 * @LastEditTime: 2022-06-24 10:01:13
 * @Description: desc
-->
<template>
  <div class="as-menu" :style="menuStyle">
    <div
      class="flex-row flex-ai-center flex-jc-center"
      v-if="hasTab && !isCollapse"
    >
      <zm-tabs
        type="pipeline"
        v-model="activeMenuTab"
        stretch
        :style="menuStyle"
      >
        <zm-tab-pane v-for="tab in tabList" :key="tab" :label="tab" :name="tab">
          <slot :name="tab">
            <AsMenu
              :tabList="[]"
              :menuConfig="menuConfig[tab]"
              height="calc(100% - 57px)"
              :show-collapse="false"
            ></AsMenu>
          </slot>
        </zm-tab-pane>
      </zm-tabs>
    </div>

    <zm-scrollbar v-else>
      <div class="menu-box">
        <div
          class="flex-row flex-ai-center flex-jc-center mgb-sm"
          v-if="canSearch"
        >
          <zm-input
            v-show="!isCollapse"
            v-model="menuSearch"
            style="width: 86%"
            placeholder="search menu"
            @input="filterMenu"
            clearable
          >
            <i
              class="zm-icon-search mgl-sm"
              slot="prefix"
              @click.prevent.stop="filterMenu"
            ></i>
          </zm-input>
        </div>

        <zm-menu
          ref="menuRef"
          :collapse.sync="isCollapse"
          :default-active="$route.path"
          :default-openeds="defaultOpends"
          :style="{ width: isCollapse ? '' : width - 20 + 'px' }"
          @close="closeMenu"
          :collapse-transition="false"
          :router="router"
        >
          <template v-for="menu in menuList">
            <MenuItem
              v-if="!menu.children"
              :menuItem="menu"
              :key="menu.index"
              :isFirst="true"
              :collapse="isCollapse"
              itemStyle="padding-left: 8px;"
            >
            </MenuItem>
            <zm-submenu :index="menu.index" :key="menu.index" v-else>
              <template slot="title">
                <i :class="isCollapse ? menu.icon : 'zm-icon-right'" />
                <div style="display: inline-block:" v-if="!isCollapse">
                  {{ menu.name }}
                </div>
                <!--- pin --->
                <div
                  v-if="!isCollapse"
                  :class="
                    !pinCache.has(menu.index, pins) ? 'hover-display-pin' : ''
                  "
                >
                  <i
                    class="iconfont icon-a-pin mgl-sm"
                    @click.prevent.stop="
                      setPin(
                        menu.index,
                        !pinCache.has(menu.index, pins) ? '' : 'delete'
                      )
                    "
                    :style="
                      !pinCache.has(menu.index, pins) ? '' : 'color: #0e71eb'
                    "
                  ></i>
                </div>
              </template>
              <!--- group --->
              <template v-for="child in menu.children">
                <MenuItem
                  v-if="!child.children"
                  :menuItem="child"
                  :key="child.index"
                  :collapse="isCollapse"
                >
                </MenuItem>
                <zm-menu-item-group :key="child.index" v-else>
                  <span slot="title">{{ child.name }}</span>
                  <MenuItem
                    v-for="childItem in child.children"
                    :key="childItem.index"
                    :menuItem="childItem"
                    :collapse="isCollapse"
                    itemStyle="padding-left: 16px"
                  >
                  </MenuItem>
                </zm-menu-item-group>
              </template>
            </zm-submenu>
          </template>
        </zm-menu>
        <div
          v-if="!menuList.length && menuList_copy && menuList_copy.length"
          class="no-data"
        >
          no matched results
        </div>
      </div>
    </zm-scrollbar>
    <transition v-if="showCollapse">
      <zm-button
        @click="isCollapse = !isCollapse"
        :class="['collapse-button', isCollapse && 'collapse', '']"
      >
        <i
          :class="isCollapse ? 'zm-icon-right-1' : 'zm-icon-left-1'"
          style="color: #141414; font-size: 18px; margin-right: 8px"
        ></i>
        {{ !isCollapse ? 'Collapse Sidebar' : '' }}
      </zm-button>
    </transition>
  </div>
</template>
<script>
import { debounce, pinCache, deepMap } from '../utils'
import cloneDeep from 'lodash/cloneDeep'
import MenuItem from './MenuItem.vue'
export default {
  name: 'AsMenu',
  components: {
    MenuItem,
  },
  props: {
    width: {
      type: Number,
      default: 240,
    },
    height: {
      type: [String, Number],
      default: '100%',
    },
    tabList: {
      type: Array,
      default: () => [],
    },
    canSearch: {
      type: Boolean,
      default: true,
    },
    menuConfig: {
      type: [Array, Object],
      default: () => [],
    },
    activeAll: {
      type: Boolean,
      default: false,
    },
    router: {
      type: Boolean,
      default: false,
    },
    showCollapse: {
      type: Boolean,
      default: true,
    },
    activeTab: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasTab() {
      return this.tabList?.length
    },
    menuList_copy() {
      if (this.hasTab) {
        return cloneDeep(this.menuConfig[this.activeMenuTab])
      } else {
        return cloneDeep(this.menuConfig)
      }
    },
    menuStyle() {
      return {
        width: this.isCollapse ? '' : `${this.width}px`,
        height: this.height,
      }
    },
  },
  data() {
    return {
      menuList: [],
      menuSearch: '',
      pinCache: pinCache,
      pins: [],
      defaultOpends: [],
      isCollapse: false,
      activeMenuTab: '',
    }
  },
  watch: {
    activeTab(v) {
      this.activeMenuTab = v
    },
    activeMenuTab(v) {
      this.$emit('update:activeTab', v)
    },
    menuConfig: {
      deep: true,
      handler() {
        this.getMenuList()
      },
    },
  },
  created() {
    if (this.hasTab) {
      this.activeMenuTab = this.activeTab || this.tabList?.[0] || ''
    }
    this.getMenuList()
    if (this.activeAll) {
      this.defaultOpends = deepMap([], this.menuList)
    } else {
      this.defaultOpends = this.pins = pinCache.getPins()
    }
  },
  methods: {
    getMenuList() {
      this.menuList = cloneDeep(this.menuList_copy)
      this.menuList = this.menuList.map((m) => {
        m.pin = pinCache.has(m.index)
        return m
      })
    },
    filterMenu: debounce(function () {
      const tempList = cloneDeep(this.menuList_copy)
      if (!this.menuSearch) return (this.menuList = tempList)
      this.menuList = tempList.filter((menu) => {
        return this.findChilds(menu)
      })
      if (this.menuList.length) {
        this.$refs.menuRef.open(this.menuList[0].index)
      }
    }, 200),
    findChilds(child) {
      if (!child.children) return this.includes(child.name)
      child.children = child.children.filter((item) => {
        return this.findChilds(item)
      })
      return !!child.children?.length
    },
    includes(item) {
      return item
        .toLocaleLowerCase()
        .includes(this.menuSearch.toLocaleLowerCase())
    },
    setPin(index, isDelete) {
      if (isDelete) {
        this.pins = pinCache.deletePin(index)
        return
      }
      this.pins = pinCache.setPins(index)
      this.$refs.menuRef.open(index)
    },
    closeMenu(menu) {
      if (this.pins.includes(menu)) {
        this.$refs.menuRef.open(menu)
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/fonts/iconfont.css';
@import '../styles/common.scss';
@mixin menu-style {
  .zm-menu-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #131619;
    min-width: 50px;
    border-radius: 8px;
    box-sizing: border-box;
    height: 39px;
    margin: 5px;
    span {
      font-size: 16px;
    }
    &.is-active {
      .nav-item,
      .nav-item a {
        color: #ffffff;
      }
      background: #0e72ed;
      [class^='zm-icon-'],
      [class^='iconfont'] {
        color: #fff;
      }
    }
  }
  .zm-menu-item-group__title {
    color: #81878c;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    margin: 5px;
    span {
      font-size: 16px;
    }
  }
  .zm-submenu__title {
    height: 39px;
    margin: 9px 5px 0 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: #131619;
    text-decoration: none;
    padding-left: 8px !important;
    span {
      font-size: 16px;
    }
    .hover-display-pin {
      display: none;
    }

    &:hover {
      .hover-display-pin {
        display: inherit;
      }
    }
  }
}
.as-menu {
  background: #f7f7fa;
  position: relative;
  overflow-y: hidden;
  overflow-x: hidden;
  box-sizing: border-box;
  overflow-x: hidden;
  padding-top: 12px;
  will-change: width;

  .zm-button--icon {
    background: #fff;
  }

  .zm-scrollbar {
    height: 100%;
    padding-bottom: 60px;
  }

  .zm-scrollbar__wrap {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
  }
  .zm-tabs {
    .zm-tabs__header {
      padding-left: 7%;
      width: 93%;
    }
    .zm-tabs__content {
      height: 100%;

      .zm-tab-pane {
        height: 100%;
      }
    }
    &.zm-tabs--pipeline > .zm-tabs__header .zm-tabs__item {
      font-size: 16px;
    }
  }
  .menu-box {
    padding-bottom: 60px;
    .zm-input__inner {
      font-size: 16px;
    }
  }

  .zm-menu {
    background: #f7f7fa;
    border-right: none;

    .zm-menu--inline {
      margin-left: 12px;
    }
    @include menu-style;
    .zm-submenu [class*=' zm-icon-'],
    .zm-submenu [class^='zm-icon-'],
    .zm-menu-item [class^='zm-icon-'],
    .zm-menu-item [class^='iconfont'] {
      color: #6e7680;
      font-size: 18px;
      margin-right: 0;
      width: 28px;
      text-align: center;
    }

    .zm-submenu__icon-arrow {
      display: none;
    }

    .is-opened {
      > .zm-submenu__title .zm-icon-right {
        transform: rotateZ(90deg);
      }
    }
  }

  .no-data {
    text-align: center;
    color: #6e7680;
  }

  .collapse-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-radius: 0;
    text-align: center;
    height: 60px;
    font-size: 16px;
    line-height: 24px;
    color: #141414;
    background: inherit;
    border-top: 1px solid #ededf4;
    border-right: none;
    border-bottom: none;
    border-left: none;

    & .zm-button__slot {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &.collapse {
      width: 64px;
    }
  }
}

.zm-menu--vertical {
  left: 60px !important;
  .zm-menu--popup {
    padding: 8px;
  }
  @include menu-style;
}
</style>
